export const environment = {
  production: true,
  environmentName: 'PRODUCTION',
  appBaseHref: '/',
  clientId: '0oa8eineldiPAh7JX4x7',
  issuer: 'https://gartner.okta.com',
  apiUrl : 'https://api.cn.gartner.com/ConferenceGAW/GetConferences' //'https://gaw.api.internal.conf.emt.aws.gartner.com/api/ConferenceGAW/GetConferences'
};
